import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'app-dialog-close-button',
  templateUrl: './dialog-close-button.component.html',
  styleUrls: ['./dialog-close-button.component.scss']
})
export class DialogCloseButtonComponent {
  @ViewChild("closeButton", {static: false}) closeButton: ElementRef;
  @Output() closeModal = new EventEmitter();
  @Input() layoutMode: string = "default";

  close() {
    this.closeButton.nativeElement.click();
  }

  closeModalHandler() {
    this.closeModal.emit()
  }
}
